// FILECONTENT_START src/common/components/Inputs/HtmlEditor/index.ts
import HtmlEditor from "./HtmlEditor";
export default HtmlEditor;
export type { HtmlEditorProps } from "./HtmlEditor";

// FILECONTENT_END src/common/components/Inputs/HtmlEditor/index.ts